import ApiService from '@/common/api.service'

const RESOURCE = 'lp'
const CLIENT_RESOURCE = 'clp'
const LpService = {
  getLp (lpCode, code, params) {
    return ApiService.query(`${RESOURCE}/${lpCode}/${code}`, params)
  },
  getClientLp (lpDir, lpCode, code, params) {
    return ApiService.query(`${CLIENT_RESOURCE}/${lpDir}/${lpCode}/${code}`, params)
  }
}
export default LpService
